module.exports = __webpack_public_path__ + "img/kid-icarus.ae337882.png";